import { render, staticRenderFns } from "./BranchReport.vue?vue&type=template&id=59cc64c5&"
import script from "./BranchReport.vue?vue&type=script&lang=js&"
export * from "./BranchReport.vue?vue&type=script&lang=js&"
import style0 from "./BranchReport.vue?vue&type=style&index=0&id=59cc64c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports